import { render, staticRenderFns } from "./MetadadosCampoDinamicoCheckbox.vue?vue&type=template&id=79027340&"
import script from "./MetadadosCampoDinamicoCheckbox.vue?vue&type=script&lang=js&"
export * from "./MetadadosCampoDinamicoCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoCheckbox.vue
// module id = 1357
// module chunks = 28